import { render, staticRenderFns } from "./LeitorQrCodeVending.vue?vue&type=template&id=2bfd1362&"
import script from "./LeitorQrCodeVending.vue?vue&type=script&lang=js&"
export * from "./LeitorQrCodeVending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports